import classNames from 'classnames';
interface Props {
  className?: string;
}
export default function SearchSkeleton({
  className
}: Props) {
  return <div className={classNames('mb-4 flex flex-col', className)} data-sentry-component="SearchSkeleton" data-sentry-source-file="search-skeleton.tsx">
            {Array(3).fill({}).map((_, i) => <div key={i} className='flex gap-2 px-2 py-1.5 lg:py-2.5'>
                        <div className='h-6 w-6 animate-pulse rounded bg-gray-100 shadow-sm'></div>
                        <div className='h-6 grow animate-pulse rounded bg-gray-100 shadow-sm'></div>
                    </div>)}
        </div>;
}